
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    StyleSheet,
    StatusBar,
    Platform
} from 'react-native';

import {
    JDTouchable,
    JDNativeSystem,
    JDImage,
    JDText,
    JDLogin,
    JDShare
} from '@jdreact/jdreact-core-lib';

import { px, pt, is_web } from '../common/utils';

class Menu extends PureComponent {
    constructor(props) {
        super(props);
        this.list = [{
            icon: img.home,
            label: '电影首页',
            fn: this.goIndex
        }, {
            icon: img.order,
            label: '查看订单',
            fn: this.goOrderList
        }];
        this.state = {
            isVisible: false
        };
    };

    render() {
        const { isVisible } = this.state;

        if (!isVisible) return null;

        return (
            <View style={ st.container }>
                <JDTouchable style={ st.overlay } onPress={ () => this.setState({ isVisible: false }) } />
                <View style={ st.wrapper }>
                    <View style={ st.more_nav_list }>
                        {this.list.map((x, i) =>
                            <JDTouchable key={ i }
                                onPress={ x.fn }
                                contentContainerStyle={ [
                                    st.nav_item,
                                    i === 0 && { borderTopWidth: 0 }
                                ] }
                            >
                                <JDImage source={ x.icon } style={ st.nav_icon } />
                                <JDText style={ st.nav_text }>{x.label}</JDText>
                            </JDTouchable>
                        )}
                    </View>
                </View>
                <View style={ st.tri_wrap }>
                    <View style={ st.tri } />
                </View>
            </View>
        );
    }

    componentDidMount() {
        const { from } = this.props;

        if (!!from && from === 'movieSchedule') {
            this.list.push({
                icon: img.share,
                label: '立即分享',
                fn: this.share
            });
        }
    }

    goIndex = () => {
        this.setState({ isVisible: false });
        is_web ? this.context.router.toIndex() : this.context.router.resetTo({ routeName: 'index' });
    }

    goOrderList = () => {
        JDLogin.isLogin().then(() => {
            jump();
        }, () => {
            JDLogin.doLogin().then(() => {
                jump();
            });
        }).catch(() => jump());

        const jump = () => {
            this.setState({ isVisible: false });
            this.context.router.jumpTo({ routeName: 'orderList' });
        };
    }

    share = () => {
        this.setState({ isVisible: false });

        const { shareInfo } = this.props;

        // let url = 'https://pro.m.jd.com/mall/active/2Hbfrq8NQumAZFDB8NnbKFrrNh1J/index.html' || shareInfo.url;
        const url = shareInfo.url || 'https://pro.m.jd.com/mall/active/2Hbfrq8NQumAZFDB8NnbKFrrNh1J/index.html';

        const title = shareInfo.title || '京东电影票 热映大片选座购票';

        const msg = shareInfo.msg || '看电影，上京东！看热映影片预告片，在线选座立即购票！';

        const logo = shareInfo.logo || 'https://storage.jd.com/ltmovie/movieLogo.jpg';

        const name = shareInfo.name || 'movie';

        JDShare.showShareDialog(url, title, msg, logo, name).then((response) => {

        }, (error) => {

        });
    }
}

const st = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 9999999,
        elevation: 9999999
    },
    overlay: {
        flex: 1,
        width: '100%',
        height: '100%'
    },
    wrapper: {
        position: 'absolute',
        top: pt(44) + (Platform.OS === 'ios' ? JDNativeSystem.statusBarHeight : Platform.OS === 'android' ? StatusBar.currentHeight : 0),
        right: pt(7),
        overflow: 'visible'
    },
    tri_wrap: {
        position: 'absolute',
        top: pt(32) + (Platform.OS === 'ios' ? JDNativeSystem.statusBarHeight : Platform.OS === 'android' ? StatusBar.currentHeight : 0),
        right: pt(5),
        width: pt(40),
        height: pt(12),
        overflow: 'hidden',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    tri: {
        width: pt(14),
        height: pt(14),
        backgroundColor: 'rgba(255,255,255,1)',
        transform: [{
            rotate: '45deg'
        }, {
            translateY: pt(5)
        }, {
            translateX: pt(9)
        }],
        shadowColor: 'rgba(0,0,0,1)',
        shadowOffset: { width: 0, height: 0 },
        shadowRadius: pt(4),
        shadowOpacity: 0.1,
        elevation: 4
    },
    more_nav_list: {
        backgroundColor: 'rgba(255,255,255,1)',
        borderRadius: px(4),
        width: pt(120),
        shadowColor: 'rgba(0,0,0,1)',
        shadowOffset: { width: 0, height: 0 },
        shadowRadius: pt(6),
        shadowOpacity: 0.1,
        elevation: 4
    },
    nav_item: {
        borderTopColor: 'rgba(0,0,0,0.1)',
        borderTopWidth: px(1),
        paddingLeft: pt(19),
        flexDirection: 'row',
        height: pt(42),
        alignItems: 'center'
    },
    nav_icon: {
        width: pt(14),
        height: pt(11),
        resizeMode: 'contain'
    },
    nav_text: {
        color: '#252525',
        fontSize: pt(13),
        marginLeft: pt(7)
    }
});

const img = {
    home: require('../img/home.png'),
    order: require('../img/order.png'),
    share: require('../img/share.png')
};

Menu.contextTypes = {
    router: PropTypes.object
};

export default Menu;
